import { Box } from '@mui/material';
import { Tappable, TappableProps } from '@telegram-apps/telegram-ui';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

const CellContainer = styled(Box)<{ }>(({ }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  padding: '12px',
  gap: '16px',
}));

interface CustomCellProps extends Omit<TappableProps, 'children'> {
  children: ReactNode;
  hideTappable?: boolean;
  contentStyle?: React.CSSProperties;
  hovered?: boolean;
  multiline?: boolean;
}

export const CustomCell: FC<CustomCellProps> = ({ 
  children, 
  hideTappable,
  contentStyle,
  onClick,
  disabled,
  hovered,
  multiline,
  className,
  ...restProps 
}) => {
  const content = (
    <CellContainer 
      style={{
        ...contentStyle,
        ...(hovered && { }),
      }}
      className={className}
    >
      {children}
    </CellContainer>
  );

  if (hideTappable || !onClick) {
    return content;
  }

  return (
    <Tappable onClick={onClick} disabled={disabled} {...restProps}>
      {content}
    </Tappable>
  );
};
